module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": ("Podgląd - " + (_vm.simpleFormData.timestamp)),
      "width": "70vw",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sections"
  }, _vm._l((_vm.formData.sections), function(section, i) {
    return _c('div', [_c('h2', {
      staticClass: "section__title"
    }, [_vm._v("Sekcja: " + _vm._s(section.name))]), _vm._v(" "), _vm._l((section.fields), function(field, i) {
      return _c('div', [_c('strong', {
        staticClass: "field__label"
      }, [_vm._v("\n                        " + _vm._s(i + 1) + ". " + _vm._s(field.label) + "\n                    ")]), _vm._v(" "), _c('p', [(field.answer.value === 'true') ? _c('span', [_c('i', {
        staticClass: "fa fa-check"
      })]) : (field.answer.kind === 'photo') ? _c('img', {
        staticClass: "field__thumbnail",
        attrs: {
          "src": field.answer.value,
          "alt": ""
        }
      }) : _c('span', [_vm._v("\n                            " + _vm._s(field.answer.value) + "\n                        ")])])])
    })], 2)
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('previousPreview')
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('nextPreview')
      }
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelForm()
      }
    }
  }, [_vm._v("Zamknij")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85863182"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomForms/PreviewDialog.vue
// module id = 783
// module chunks = 0